import React from 'react'
import PropTypes from 'prop-types'

import CheckList from './CheckList'
import { withContext } from '../Context'

export const SegmentName = 'EngagementStage'

export const Criteria = 'Must'

export const ENGAGEMENT_STAGES = ['Following', 'Applying', 'Applied']

export const EngagementStage = ({ currentValues, onChange }) => (
  <CheckList
    selectedValues={currentValues}
    values={ENGAGEMENT_STAGES}
    labels={ENGAGEMENT_STAGES}
    onChange={(values) => onChange(Criteria, SegmentName, values)}
    required
  />
)

EngagementStage.propTypes = {
  currentValues: PropTypes.array,
  segment: PropTypes.object,
  onChange: PropTypes.func.isRequired,
}
EngagementStage.defaultProps = {
  currentValues: [],
}

export default withContext(EngagementStage)
